import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';

//Import Icons
import FeatherIcon from 'feather-icons-react';

// Import Images
import ImageCombined from '../../assets/images/v3/combined.png';
import ImageChrome from '../../assets/images/chrome.png';
import ImageFirefox from '../../assets/images/firefox.png';
import ImageEdge from '../../assets/images/edge.png';
import ImageAppStore from '../../assets/images/5a902db97f96951c82922874.png';
import ImageGooglePlay from '../../assets/images/5a902dbf7f96951c82922875.png';

// Modal Video
import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

const Section = () => {
  const [open, setOpen] = useState(false);
  const [videoId, setVideoId] = useState('');

  const openModal = (id) => {
    setVideoId(id);
    setOpen(true);
  };

  return (
    <React.Fragment>
      <section
        className="bg-half-170 border-bottom agency-wrapper d-table w-100"
        id="home"
      >
        <Container>
          <Row className="align-items-center">
            <Col lg={7} md={7} className="order-1 order-md-2">
              <div className="title-heading mt-4 ms-lg-5">
                <h1 className="heading mb-3">
                  Learn English Vocabulary{' '}
                  <span className="text-primary">While You Browse</span>
                </h1>
                <p className="para-desc text-muted">
                  HighVocab is a browser extension for English learners. Save
                  new words instantly, review them in context, and build a
                  vocabulary that actually sticks.
                </p>
                {/* Browser extension group */}
                <p style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#94a3b8', margin: '20px 0 8px' }}>
                  Browser Extension
                </p>
                <div className="d-flex flex-wrap gap-2">
                  <a href="https://chrome.google.com/webstore/detail/highvocab-vocabulary-buil/nmalijlbcckplnamalenpdaafacfeemd?hl=en" target="_blank" rel="noreferrer" className="btn btn-primary d-inline-flex align-items-center" style={{ gap: 8 }}>
                    <img src={ImageChrome} style={{ width: 20, height: 20 }} alt="" />
                    Install on Chrome
                  </a>
                  <a href="https://microsoftedge.microsoft.com/addons/detail/highvocab-vocabulary-bui/dfpolnmicooilcndegandafkmooecmei" target="_blank" rel="noreferrer" className="btn btn-primary d-inline-flex align-items-center" style={{ gap: 8 }}>
                    <img src={ImageEdge} style={{ width: 20, height: 20 }} alt="" />
                    Install on Edge
                  </a>
                  <a href="https://addons.mozilla.org/en-US/firefox/addon/highvocab-vocabulary-builder/" target="_blank" rel="noreferrer" className="btn btn-primary d-inline-flex align-items-center" style={{ gap: 8 }}>
                    <img src={ImageFirefox} style={{ width: 20, height: 20 }} alt="" />
                    Install on Firefox
                  </a>
                </div>

                {/* Mobile app group */}
                <p style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#94a3b8', margin: '18px 0 8px' }}>
                  Mobile App
                </p>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <a href="https://apps.apple.com/us/app/highvocab/id6770623659" target="_blank" rel="noreferrer" style={{ display: 'inline-block', lineHeight: 0 }}>
                    <img src={ImageAppStore} alt="Download on the App Store" style={{ height: 42, width: 'auto' }} />
                  </a>
                  <div style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>
                    <img src={ImageGooglePlay} alt="Get it on Google Play" style={{ height: 42, width: 'auto', opacity: 0.4, filter: 'grayscale(40%)' }} />
                    <span style={{ position: 'absolute', top: -8, right: -6, background: '#f59e0b', color: '#fff', fontSize: '0.65rem', fontWeight: 700, borderRadius: 999, padding: '2px 7px', lineHeight: 1.6, whiteSpace: 'nowrap' }}>
                      Coming soon
                    </span>
                  </div>
                </div>

                {/* Video links */}
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <div className="d-flex align-items-center gap-2">
                    <Link to="#" onClick={() => openModal('VW8W350kY1w')} className="btn btn-icon btn-pills btn-primary lightbox">
                      <FeatherIcon icon="video" className="icons" />
                    </Link>
                    <span className="fw-bold text-uppercase small">Product Tour</span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Link to="#" onClick={() => openModal('cRfNrdFg7xw')} className="btn btn-icon btn-pills btn-primary lightbox">
                      <FeatherIcon icon="video" className="icons" />
                    </Link>
                    <span className="fw-bold text-uppercase small">How to use</span>
                  </div>
                </div>
              </div>

              <ModalVideo
                channel="youtube"
                isOpen={open}
                videoId={videoId}
                onClose={() => setOpen(false)}
              />
            </Col>
            <Col
              lg={5}
              md={5}
              className="order-2 order-md-1 mt-4 pt-2 mt-sm-0 pt-sm-0"
            >
              <img
                src={ImageCombined}
                className="img-fluid section-image d-none d-md-block"
                style={{ width: '80%' }}
                alt=""
              />
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Section;
